<template>
  <div class="finish">
    <app-container>
      <h1 class="finish__title">Отличная работа <span class="finish__like">&#128077;</span></h1>
      <div class="page-grid">
        <div class="info">
          <p class="info__text">
            Ты закончил профориентационное тестирование. Разбор результатов ждет тебя на консультации со специалистом. А пока ты ждешь приглашение, попробуй спрогнозировать свою карьеру с видео о профессиях будущего.
          </p>
        </div>
        <iframe
          class="video"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/-DSQp4-BSfw"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
        <img
          class="page-grid__image"
          src="@/assets/images/finish-bg.svg"
        >
      </div>
    </app-container>
  </div>
</template>

<script>
import AppContainer from '../components/Base/AppContainer';

export default {
  name: 'Finish',
  components: {
    AppContainer,
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.page-grid {
  grid-template-columns: auto 1fr;
  position: relative;
  &__image {
    max-width: 110px;
    position: absolute;
    top: -28px;
    right: -40px;
    margin: 0;
  }
}
.finish {
  padding: 30px 0 50px 0;
  position: relative;
  &__like {
    position: absolute;
    top: 0;
    transform: translateY(30%)
  }
}
.info {
  width: 430px;
  background: #FFFFFF;
  border: 1px solid #DBDBDB;
  box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
  border-radius: 8px;
  padding: 24px 16px;
  margin-bottom: auto;
  &__text {
    font-size: 19px;
    margin: 0;
    &_border {
      border-top: 1px gray solid;
      padding: 20px 0;
    }
  }
}

.video {
  margin-left: 24px;
}
  @media screen and (max-width: 1200px) {
    .page-grid {
      grid-template-columns: 1fr;
      .info {
        width: 70%;
      }
      .video {
        margin-left: 0;
        margin-top: 24px;
        width: 70%;
        height: 435px;
      }
      &__image {
        max-width: 20%;
        position: absolute;
        top: -28px;
        left: 75%;
        right: auto;
        margin: 0;
      }
    }
    .finish {
      &__like {
        transform: translateY(40%);
      }
    }
  }

  @media screen and (max-width: 992px) {
    .page-grid {
      grid-template-columns: 1fr;

      .info {
        width: 100%;
      }

      .video {
        margin-left: 0;
        margin-top: 24px;
        width: 100%;
        height: 435px;
      }

      &__image {
        display: none;
      }
    }
    .finish {
      &__like {
        transform: translateY(30%);
      }
    }
  }

  @media screen and (max-width: 576px) {
    .page-grid {
      grid-template-columns: 1fr;

      .info {
        width: 100%;
      }

      .video {
        margin-left: 0;
        margin-top: 24px;
        width: 100%;
        height: 162px;
      }

      &__image {
        display: none;
      }
    }
    .finish {
      &__like {
        transform: translateY(140%);
      }
      &__button {
        width: 100%;
      }
    }
    .info {
      width: auto;
      &__text {
        border: 0;
      }
    }
  }
</style>
